import { render, staticRenderFns } from "./HomeInvoices.vue?vue&type=template&id=23a75c8f&"
import script from "./HomeInvoices.vue?vue&type=script&lang=js&"
export * from "./HomeInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports